import axios from "axios";

import {
  authHeader,
  authDeviceWithDomainHeader,
} from "../../authServices/auth.header";

const API_URL = process.env.VUE_APP_ROOT_API;
class PropertyUserService {
  async getPropertyUserList(filter = "") {
    return await axios
      .get(API_URL + `pbx-users/users` + filter, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  async addPropertyrUser(data) {
    return await axios
      .post(API_URL + `pbx-users/users`, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  async getPropertyUserDetails(property_user_id) {
    return await axios
      .get(API_URL + `pbx-users/users/${property_user_id}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  async updatePropertyUser(property_user_id, data) {
    return await axios
      .patch(API_URL + `pbx-users/users/${property_user_id}`, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  async deletePropertyUser(property_user_id) {
    return await axios
      .delete(API_URL + `pbx-users/users/${property_user_id}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  //  DASHBOARD RELATED APIs
  async getDashboardData() {
    return await axios
      .get(API_URL + "pbx-common/dashboard", {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // ALERTS RELATED APIs
  // Get Alert List
  async getAlertsList(filter = "") {
    return await axios
      .get(API_URL + "notification/alerts" + filter, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Remove Alert/s From list
  async updateAlertList(data) {
    return await axios
      .patch(API_URL + "notification/alerts", data, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
}

export default new PropertyUserService();
